export const CANDU_PORTAL_CLASS = 'candu_portal';

export const canduPortalId = (slug: string) => `candu_portal_${slug}`;
